import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HelpTopic, HelpTopicKey } from '@core/models/domain/help.domain';
import { HelpService } from '@core/services/help.service';
import { HELP_PAGE_ROUTE } from '@core/services/help-routes';

export interface HelpPanelData {
  topicKey: HelpTopicKey;
}

/**
 * Contextual help for one section, opened by the Help button on that section's page.
 *
 * It shows the same content the Help & FAQ page shows for this topic, read from {@link HelpService}
 * rather than written into the template, so the two can never drift apart.
 */
@Component({
  selector: 'app-help-panel',
  templateUrl: './help-panel.component.html',
  styleUrls: ['./help-panel.component.scss'],
  standalone: false,
})
export class HelpPanelComponent {
  readonly topic: HelpTopic | undefined;

  constructor(
    private dialogRef: MatDialogRef<HelpPanelComponent>,
    private router: Router,
    helpService: HelpService,
    @Inject(MAT_DIALOG_DATA) data: HelpPanelData
  ) {
    this.topic = helpService.topic(data.topicKey);
  }

  close(): void {
    this.dialogRef.close();
  }

  /** The dialog has to go before the navigation, otherwise it sits over the page it opened. */
  viewAllHelp(): void {
    this.dialogRef.close();
    this.router.navigate([HELP_PAGE_ROUTE], { fragment: this.topic?.key });
  }
}
